import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import Table from '../../components/Table/Table';
import TagList from '../TagList/TagList';
import Fader from '../../components/Loaders/Fader';

import { RIDING_TABLE_HEADER } from '../../../util/constants/AppConstants';
import { getAllRidings } from '../../../http/ridingAPI';
import { assignWidgets, getAllWidgets } from '../../../http/widgetAPI';

const Ridings = () => {
  const config = useSelector((state) => state.config.config);
  const backgroundEffectState = useSelector((state) => state.settings.backgroundEffect);

  const [backgroundEffectChecked, setBackgroundEffectChecked] = useState(backgroundEffectState);

  const [dataPreviewLoading, setDataPreviewLoading] = useState(true);
  const [ridingsData, setRidingsData] = useState([]);

  const [activeWidgetsList, setActiveWidgetsList] = useState([]);
  const [activeRidingId, setActiveRidingId] = useState(null);
  const [taggingType, setTaggingType] = useState('');

  const [widgetsData, setWidgetsData] = useState([]);

  const [isTaggingActive, setIsTaggingActive] = useState(false);

  const addItem = (id, list, type, setActiveList) => {
    setTaggingType(type);
    setIsTaggingActive(true);
    setActiveList(list);
    setActiveRidingId(id);
  };

  const handleRenderList = (list, id, type) => {
    return list.map((item) => {
      if (item === '+') {
        return (
          <span className="search-label add" onClick={() => addItem(id, list, type, setActiveWidgetsList)}>
            +
          </span>
        );
      }
      return <span className="search-label">{item.name}</span>;
    });
  };

  const handleSetRidingsData = (ridingsData) => {
    const ridingsArr = ridingsData.map((item) => ({
      id: item.id,
      name: item.name,
      widgets: handleRenderList([...item.widgets.sort((a, b) => a.id - b.id), '+'], item.id, 'widgets'),
    }));
    setRidingsData(ridingsArr);
  };

  const handleGetRidingsData = async () => {
    const res = await getAllRidings(config);

    if (res.status === 200) {
      setDataPreviewLoading(false);
      handleSetRidingsData(res.data.ridings);
    } else {
      console.log('ERROR: Grabbing Ridings');
    }
  };

  const ridingsTableColumns = useMemo(() => RIDING_TABLE_HEADER, []);

  const handleGetWidgetsData = async () => {
    const res = await getAllWidgets(config);

    if (res.status === 200) {
      setWidgetsData(res.data.widgets);
    } else {
      console.log('ERROR: Grabbing Widgets');
    }
  };

  const handleTagsCancel = () => {
    setIsTaggingActive(false);
    setActiveRidingId(null);
  };

  useEffect(() => {
    if (dataPreviewLoading && config.api) {
      handleGetRidingsData();
    }
  }, [dataPreviewLoading, config]);

  useEffect(() => {
    setBackgroundEffectChecked(backgroundEffectState);
  }, [backgroundEffectState]);

  useEffect(() => {
    if (config.api && dataPreviewLoading) {
      handleGetWidgetsData();
    }
  }, [config]);

  return (
    <div className="dashboard-components">
      <div className="dc-left full">
        <div className="sentiment-trend chart-component">
          {!dataPreviewLoading ? (
            <Table columns={ridingsTableColumns} data={ridingsData} searchLabel="Search for Ridings" />
          ) : (
            <div className="sentiment-charts">
              <Fader />
            </div>
          )}
        </div>

        {isTaggingActive && (
          <TagList
            isOpen={isTaggingActive}
            taggingType={taggingType}
            taggingList={widgetsData}
            startTaggingList={activeWidgetsList}
            handleTagsCancel={handleTagsCancel}
            activeItemId={activeRidingId}
            handleGetItemsData={handleGetRidingsData}
            setIsTaggingActive={setIsTaggingActive}
            request={assignWidgets}
          />
        )}
      </div>
    </div>
  );
};

export default Ridings;
